import { Step, StepValidationState } from "../../../../../interfaces/step";
import { Stepper } from "../../../../../interfaces/stepper";
import { DebtorsComponent } from "../../../../orders/debtors/debtors.component";
import { SecuredPartiesComponent } from "../../../../orders/secured-parties/secured-parties.component";
import { CollateralComponent } from "../../../../orders/collateral/collateral.component";
import { ReviewComponent } from "../../../../orders/review/review.component";
import { BCLienDetailsComponent } from "../../../../orders/lien-details/bc-lien-details/bc-lien-details.component";
import { RegisteringAgentComponent } from "../../../../orders/registering-agent/registering-agent.component";
import { ConfigurationState } from "reg-hub-common";

export class BCLienStepper implements Stepper {

    steps: Step[];

    constructor(configurationState: ConfigurationState) {
        this.steps = [
            { title: "Details", content: BCLienDetailsComponent, validationState: StepValidationState.DefaultState },
            { title: "Debtors", content: DebtorsComponent, validationState: StepValidationState.DefaultState },
            { title: "Sec. Parties", content: SecuredPartiesComponent, validationState: StepValidationState.DefaultState },
            ...(
                configurationState.shouldShowRegisteringAgentTab()
                    ? [{ title: "Agent", content: RegisteringAgentComponent, validationState: StepValidationState.DefaultState }]
                    : []
            ),
            { title: "Collateral", content: CollateralComponent, validationState: StepValidationState.DefaultState },
            { title: "Review", content: ReviewComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}